import React, { useState } from 'react';
import UserAvatar from './UserAvatar';
import { makeStyles, TextField } from '@material-ui/core';
import { CustomizedButton } from '@components/Customized';
import { colorSet } from '@components/Provider';
import { CapaQuotationSpecificAnnotationComment } from '@generated/graphql';

interface AnnotationDetailCommentItemEditProps {
  comment: CapaQuotationSpecificAnnotationComment;
  editedComment: React.MutableRefObject<string>;
  onUpdateComment: () => Promise<void>;
  setEditMode: React.Dispatch<React.SetStateAction<boolean>>;
}

const AnnotationDetailCommentItemEdit: React.FunctionComponent<AnnotationDetailCommentItemEditProps> = ({
  comment,
  editedComment,
  onUpdateComment,
  setEditMode
}) => {
  const [isValid, setIsValid] = useState<boolean>(false);
  const { editContainer } = useStyles();

  return (
    <div className={editContainer}>
      <UserAvatar userName={comment.userName ?? ''} size={32} />
      <div className="edit-input-section">
        <TextField
          variant="outlined"
          multiline
          fullWidth
          className="comment-edit-input"
          defaultValue={comment.comment}
          inputProps={{
            maxLength: 5000
          }}
          onChange={(e) => {
            let value = e.target.value;

            if (!value) {
              setIsValid(false);
            } else {
              setIsValid(true);
            }

            if (value.length > 5000) {
              value = value.slice(0, -1);
            }

            editedComment.current = value;
          }}
          onKeyPress={(e) => {
            if (!e.shiftKey && e.key === 'Enter' && editedComment.current) {
              onUpdateComment();
              editedComment.current = '';
            }
          }}
        />
        <div className="comment-edit-button-group">
          <CustomizedButton
            color="default"
            variant="contained"
            size="small"
            onClick={() => {
              editedComment.current = '';
              setEditMode(false);
            }}
          >
            취소
          </CustomizedButton>
          <CustomizedButton
            color="primary"
            size="small"
            variant="contained"
            disabled={!isValid}
            onClick={() => {
              onUpdateComment();
              setEditMode(false);
            }}
          >
            완료
          </CustomizedButton>
        </div>
      </div>
    </div>
  );
};

export default AnnotationDetailCommentItemEdit;

const useStyles = makeStyles(() => ({
  editContainer: {
    width: '100%',
    display: 'flex',
    gap: '12px',
    '& .edit-input-section': {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      '& .comment-edit-input': {
        '& .MuiOutlinedInput-root': {
          border: `1px solid ${colorSet.gray400}`,
          borderRadius: '8px 8px 0px 0px',
          '& fieldset': {
            border: 'none'
          }
        }
      },
      '& .comment-edit-button-group': {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
        border: `1px solid ${colorSet.gray400}`,
        borderTop: 'none',
        borderRadius: '0px 0px 8px 8px',
        padding: '12px 16px',
        gap: '8px'
      }
    }
  }
}));
